<template>
  <button :type="type" :disabled="disabled">
    <slot>
      <SvgIcon v-if="icon" v-bind="iconProps" />
    </slot>
  </button>
</template>

<script lang="ts" setup>
import type { SvgIconProps } from '@/types/props'

const { type = 'button', ...iconProps } = defineProps<
  {
    type?: 'button' | 'submit'
    disabled?: boolean
  } & Partial<SvgIconProps>
>()
</script>

<style lang="scss" scoped>
button {
  position: relative;
  @include centering;

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
  }
}
</style>
